// eslint-disable-next-line spaced-comment
export const isIE = /*@cc_on!@*/ false || !!(document as any).documentMode;
